"use strict";

var LoggerInstance = require("js-logger").get("ProductActions");

var ActionsHelper = require("../actions/ActionsHelper");

var CheckoutApi = require("../checkoutComponents/CheckoutApi");

var SuggestedDonationHelper = require("../commonComponents/SuggestedDonationHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Spinner = require("../client/Spinner");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var ProductStore = require("../stores/ProductStore");

var ProductActions = {
	setQuantity: function (selectedQuantity, tangibleCode, context, isInitialization) {
		Dispatcher.dispatch({
			actionType: Constants.PRODUCT_SET_QUANTITY,
			selectedQuantity,
			tangibleCode,
			context
		});

		// Call into window.CheckoutActions to re-apply the coupon to the current
		// product information. If window.CheckoutActions does not exists, we are
		// probably in a context where it has not been initialized, like a carousel
		// on a non-checkout-related page.
		if (window.CheckoutActions) {
			window.CheckoutActions.reapplyOnePageCoupon(isInitialization);
		}
	},

	addToCart: function (event, context, tangibleCode, successCallback) {
		try {
			event = ProductActions._getEventOrReturn(event, "Add To Cart called successfully.", /*preventDefaultInDesignMode*/false);
			if (!event) {
				return;
			}

			// Get context + Id to determine the component to validate
			var $suggestedDonationComponent;
			if (context && context.indexOf("_") !== -1) {
				var contextType = context.split("_")[0];

				if (contextType === "search") {
					$suggestedDonationComponent = $(event.target)
						.closest("[data-component='searchResults.product']")
						.find("[data-component='suggestedDonationAmount']");
				} else if (contextType === "category" || contextType === "carousel") {
					$suggestedDonationComponent = $(event.target)
						.closest("[data-component='category.product'],[data-component='carousel.product']")
						.find("[data-component='suggestedDonationAmount']");
				}
			} else {
				$suggestedDonationComponent = $("[data-component='suggestedDonationAmount']");

				//Make sure we do not get suggested donation inputs that are underneath category, carousel, or searchResults.
				$suggestedDonationComponent = $suggestedDonationComponent.filter((index, element) => {
					var $element = $(element);
					return !$element.parents("[data-component='category.product'],[data-component='carousel.product'],[data-component='searchResults.product']").length;
				});
			}

			// Validate the form, ValidationHelper handles alerting if validation fails.
			Spinner.showSpinner();
			ValidationHelper.validate({
				components: [$suggestedDonationComponent]
			}).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				var shoppingCartData = ProductActions.getShoppingCartData({ context, tangibleCode });
				CheckoutApi.addToCart(shoppingCartData).then((addToCartResponse, textStatus, jqXHR) => {
					if (addToCartResponse.success) {
						LoggerInstance.debug(addToCartResponse);

						if (typeof successCallback === "function") {
							successCallback();
							Spinner.removeSpinner();
						} else {
							window.location = "/shoppingcart";
						}
					} else {
						var errorMessage = ProductStore.getWizardValue(
							WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
							WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
							{ tangibleType: "product" }
						);

						BootstrapPrompt.alert(errorMessage);
						Spinner.removeSpinner();
					}
				});
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	getShoppingCartData: function (cartDataOptions) {
		cartDataOptions = cartDataOptions || {};

		var orderInformation = ProductStore.getOrderInformation(cartDataOptions);
		var { product, isShippable, quantity, suggestedDonation, warehouse } = orderInformation;

		var defaultSuggestedDonation = ProductStore.get("suggestedDonationAmount");
		var userEnteredSuggestedDonation = suggestedDonation && (+defaultSuggestedDonation !== +suggestedDonation);

		// Adding cartItems to SE shopping cart
		var cartItems = {
			products: [{
				product,
				isShippable,
				quantity,
				suggestedDonationUserProvided: userEnteredSuggestedDonation,
				suggestedDonation: suggestedDonation,
				warehouse
			}]
		};

		return { cartItems, product, quantity };
	},

	initializeResultSuggestedDonations: function ($component, context) {
		var componentContext = context.split("_")[0];
		if (componentContext === "search") {
			componentContext = "searchResults";
		}

		$component.find(`[data-component="${componentContext}.product"] [data-component="suggestedDonationAmount"]`).each((index, item) => {
			var $item = $(item);
			var $resultItem = $item.closest(`[data-component="${componentContext}.product"]`);
			var productCode = $resultItem.attr("data-product-code");
			var suggestedDonationAmount = $resultItem.attr("data-suggested-donation");

			SuggestedDonationHelper.initializeDonationAmount(
				null, /*checkoutDispatcher*/
				$item,
				productCode,
				context,
				suggestedDonationAmount
			)
		});
	},

	/**
	 * This method is called by checkout store to determine if we should be updating payment information.
	 */
	shouldHidePaymentInformation: function () {
		// TODO - #8915 When we have coupons on OPCO we need to check for a $0 checkout.
		return {
			hideOneTimeOnlyPayments: false,
			hideAllPayments: false
		};
	},

	/**
	 * This method is called when checkout store initializes. It provides a callback method to be used when
	 * this tangible's concept of a total amount has changed. This will let checkout store determine if
	 * payment information should be hidden - in conjunction with shouldHidePaymentInformation().
	 * @param handleTotalChange the callback method to trigger a total amount update.
	 */
	setChangeHandlerMethod: function (handleTotalChange) {
		this._handleTotalChange = handleTotalChange;
	},

	triggerTotalChangedHandler: function () {
		if (_.isFunction(this._handleTotalChange)) {
			this._handleTotalChange();
		}
	},

	initializeProducts: function (checkoutDispatcher) {
		// initialize any suggested donation inputs.
		var hasSuggestedDonation = false;
		$('[data-component="suggestedDonationAmount"]').each((index, $component) => {
			// determine parent
			var isSearchOrCategory = $component.closest('[data-component="searchResults.product"],[data-component="category.product"]');

			if (isSearchOrCategory) {
				// TODO - #8763 - Search Results/Category Support
				SuggestedDonationHelper.initializeDonationAmount(checkoutDispatcher, $component, "productCode", "search");
			} else {
				SuggestedDonationHelper.initializeDonationAmount(checkoutDispatcher, $component);
				hasSuggestedDonation = true;
			}
		});

		if (hasSuggestedDonation) {
			checkoutDispatcher.dispatch({
				actionType: Constants.TAX_UPDATED,
				taxAmount: 0
			});
		}
	},

	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.PRODUCT_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	_getEventOrReturn: function (event, isDesignModeMessage, preventDefaultInDesignMode) {
		return ActionsHelper.getEventOrReturn(event, ProductStore.get("isDesignMode"), isDesignModeMessage, preventDefaultInDesignMode);
	}
};

module.exports = ProductActions;


// WEBPACK FOOTER //
// ./Javascript/actions/ProductActions.jsx